import $ from "jquery";
import Rellax from "rellax";
import AOS from "aos";
import "slick-carousel";
import "is-in-viewport";
import reframe from "reframe.js";
import OnScreen from "onscreen";

$(function() {
  /* Menu */
  $("header .hamburger").click(function() {
    if ($("body").hasClass("open")) {
      $("body").removeClass("open");
    } else {
      $("body").addClass("open");
    }
  });

  $(".slider").slick({
    arrows: true,
    dots: true,
    draggable: true,
    infinite: true,
    nextArrow:
      '<span class="control next"><i class="fas fa-caret-right"></i></span>',
    prevArrow:
      '<span class="control prev"><i class="fas fa-caret-left"></i></span>',
    pauseOnHover: true,
    slidesToShow: 1,
    speed: 300,
  });

  $(".image-slider").slick({
    arrows: false,
    dots: true,
    draggable: true,
    infinite: true,
    pauseOnHover: true,
    slidesToShow: 1,
    speed: 300,
  });

  $(document).on("click", "a.load-more", function(e) {
    const href = $(this).attr("href");
    const button = $(this);
    $(button).text("Loading");
    $.ajax({
      url: href,
      success(data) {
        $(button).remove();
        $(".loaded-items").append(
          $(data)
            .find(".loaded-items")
            .html()
        );
        $(".load-buttons").append(
          $(data)
            .find(".load-buttons")
            .html()
        );
        itemsCount();
      },
    });
    e.preventDefault();
    return false;
  });

  $(document).on("change", "select[name=category]", function(e) {
    const href = $(this).val();
    $(".loaded-items").html("");
    $(".load-buttons").html('<span class="loading"></span>');
    $.ajax({
      url: href,
      success(data) {
        $(".loaded-items").html(
          $(data)
            .find(".loaded-items")
            .html()
        );
        $(".load-buttons").html("");
        $(".load-buttons").html(
          $(data)
            .find(".load-buttons")
            .html()
        );
        $(".filter").html(
          $(data)
            .find(".filter")
            .html()
        );
        history.pushState({}, "", href);
      },
    });
    e.preventDefault();
    return false;
  });

  $(document).on("submit", "form.entry-search", function(e) {
    const action = $(this).attr("action");
    const href =
      action +
      $(this)
        .find("input")
        .val();
    $(".loaded-items-alt").html("");
    $.ajax({
      url: href,
      success(data) {
        $(".loaded-items-alt").html(
          $(data)
            .find(".loaded-items-alt")
            .html()
        );
        history.pushState({}, "", href);
      },
    });
    e.preventDefault();
    return false;
  });

  $(document).on("change", "select[name=scroll]", function(e) {
    const href = $(this).val();
    $("html,body").animate({ scrollTop: $(href).offset().top - 160 }, "slow");
    e.preventDefault();
    return false;
  });

  $(document).on("change", "select#career-location", function(e) {
    const email = $(this)
      .find(":selected")
      .attr("data-email");
    $("input[name=toEmail]").val(email);
  });

  $(document).on("change", "select#general-position", function(e) {
    const position = $(this)
      .find(":selected")
      .val();
    $("input#career-position").val(position);
  });

  /* Parallax */
  if ($(".rellax").length) {
    const rellax = new Rellax(".rellax", {
      center: true,
    });
  }
  function parallax() {
    $(".parallax").each(function() {
      const scroll = $(document).scrollTop() - $(this).offset().top;
      $(this).css({
        "background-position": `center ${0.2 * scroll}px`,
      });
    });
  }
  parallax();
  $(window).scroll(function() {
    parallax();
  });

  /* Page animations */
  AOS.init({
    easing: "ease-out-back",
    duration: 1000,
  });
});

/*
	By Osvaldas Valutis, www.osvaldas.info
	Available for use under the MIT License
*/

("use strict");

(function(document, window, index) {
  var inputs = document.querySelectorAll(".file");
  Array.prototype.forEach.call(inputs, function(input) {
    var label = input.nextElementSibling,
      labelVal = label.innerHTML;

    input.addEventListener("change", function(e) {
      var fileName = "";
      if (this.files && this.files.length > 1)
        fileName = (this.getAttribute("data-multiple-caption") || "").replace(
          "{count}",
          this.files.length
        );
      else fileName = e.target.value.split("\\").pop();

      if (fileName) label.querySelector("span").innerHTML = fileName;
      else label.innerHTML = labelVal;
    });

    // Firefox bug fix
    input.addEventListener("focus", function() {
      input.classList.add("has-focus");
    });
    input.addEventListener("blur", function() {
      input.classList.remove("has-focus");
    });
  });
})(document, window, 0);

// user location
jQuery(function($) {
  function setLocation(lat, lng) {
    var data = {
      lat: lat,
      lng: lng,
    };
    data[window.SERVD_CSRF_TOKEN_NAME] = window.$app.csrfTokenValue;

    if(document.querySelector('[name=' + window.SERVD_CSRF_TOKEN_NAME + ']')){
      var dynamicCsrfInput = document.querySelector('[name=' + window.SERVD_CSRF_TOKEN_NAME + ']');
      data[window.SERVD_CSRF_TOKEN_NAME] = dynamicCsrfInput.value;
    }

    $.ajax({
      type: "POST",
      url: "actions/selfgeolocation/geo-location/set-location",
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      success: function(res) {
        location.reload();
      },
    });

    return false;
  }

  window.addEventListener('geoLocationReady', function(){
    // request location if not set
    if (!window.$app.curLocationId && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(position) {
        setLocation(position.coords.latitude, position.coords.longitude);
      });
    }
  })
  

  window.$app.setLocation = setLocation;
});



// WEBPACK FOOTER //
// ./assets/js/main.js